var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5201 9.30035C16.0701 9.92035 14.7101 10.6103 15.3601 11.5103C15.6701 11.9403 16.2901 11.9603 16.6601 11.5903C17.3901 10.7203 18.5001 9.93035 19.1901 9.06035C19.4901 8.68035 19.5001 8.22035 19.1701 7.85035C18.3001 7.12035 17.5101 6.01035 16.6401 5.32035C15.9701 4.79035 15.1001 5.24035 15.2201 6.11035C15.2901 6.61035 16.2401 7.21035 16.5201 7.64035H6.73006C1.15006 8.35035 1.21006 16.2803 6.81006 16.8903H16.1901C17.1101 16.7403 17.1301 15.4203 16.2301 15.2303H7.16006C4.68006 15.1703 3.30006 12.2703 4.93006 10.3503C5.38006 9.82035 6.30006 9.30035 7.01006 9.30035H16.5201Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.2cdd389cf67cc6518a46e81e854ae629.svg";
export { ForwardRef as ReactComponent };